export default __webpack_public_path__ + "static/media/377.11b61e43.gif";